<template>
	<div class="amount" :class="productType=='DFVIP'?'current':''">
		<div class="title" v-text="productType=='DFVIP'?'DF.VIP':'Funpera'"></div>
		<div class="order">Order NO：<span>{{onTheWayOrder.orderId}}</span></div>
		<div class="loan-wrap">
			<div class="loan">
				<img src="./img/current.png"/>
				<div>Submitted</div>
			</div>
			
			<div class="loan">
				<img src="./img/current.png"/>
				<div>Final Review</div>
			</div>
			<div class="loan">
				<img src="./img/loader.png"/>
				<div v-text="onTheWayOrder.status==65 ? 'Issue Failed' : 'Lending'" />
			</div>
		</div>
		<a v-if="onTheWayOrder.status==65" class="jump" :href="`./orderDetails.html?orderId=${onTheWayOrder.orderId}`">Loan disbursement failed, please click here update your receive account.</a>
	</div>
</template>

<script>
export default{
    data(){
        return {
			
        }
    },
	
	props:{
		onTheWayOrder:{
			type:Object,
			default:()=>{}
		},
		productType:{
			type:String,
			default:""
		}
	},

    methods:{
		
    }
}
</script>

<style scoped>
.amount{box-shadow: 0px 3px 20px rgb(0 0 0 / 10%);border-radius: 0.2rem;margin: 0 0.3rem 0.3rem 0.3rem;padding: 0 0.4rem 0.3rem 0.4rem;color: #FF8F1F;background: #fff;}
.current{color:#667FFB}
.amount .title{text-align: center;font-size: 0.5rem; font-weight: bolder;} 
.amount .loan-wrap{display: flex;align-items: center;justify-content: space-between;}
.amount .loan{margin: 0.2rem 0;display: flex;flex-direction:column;align-items: center;font-size: 0.32rem;}
.amount .order{font-size: 0.32rem;font-weight: bold;font-size: 0.32rem;}
.amount .order span{font-size: 0.32rem;}
.jump{ line-height: 0.36rem; text-decoration: underline; font-size: 0.28rem; color: #ff4e4c;}
</style>
